import { FC } from 'react';
import type { PopoverProps } from '@mui/material';
import { Popover as MuiPopover } from '@mui/material';

export const Popover: FC<PopoverProps> = ({ children, ...props }) => {
  return (
    <MuiPopover
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.10)',
          },
        },
      }}
      {...props}
    >
      {children}
    </MuiPopover>
  );
};
